export default (props) => (
  /**
   * Icone de um circulo metade branco, metade preto.
   * Responsável pela transparência da camada importada.
   */  
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >  
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.39453 11C9.15596 11 11.3945 8.76142 11.3945 6C11.3945 3.23858 9.15596 1 6.39453 1C3.63311 1 1.39453 3.23858 1.39453 6C1.39453 8.76142 3.63311 11 6.39453 11ZM6.39453 12C9.70824 12 12.3945 9.31371 12.3945 6C12.3945 2.68629 9.70824 0 6.39453 0C3.08082 0 0.394531 2.68629 0.394531 6C0.394531 9.31371 3.08082 12 6.39453 12Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.45117 9.74901C8.48305 9.71879 10.1209 8.06226 10.1209 6.02319C10.1209 3.98412 8.48305 2.32759 6.45117 2.29736V9.74901Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
  </svg>
  
);
